<div class="flex h-screen overflow-hidden font-inter bg-gray-50 dark:bg-gray-900 relative">

  <!-- Left Column -->
  <div class="flex flex-col h-screen">
    <!-- Header (Logo + Title) outside sidebar -->
    <div
      class="flex items-center gap-4 px-6 py-4 ml-4 mt-5 z-20 relative cursor-pointer 
             bg-white hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 
             rounded-2xl transition-all duration-300 shadow-md hover:shadow-xl 
             border border-gray-100 group"
      routerLink="/corporate/today-trends"
      matRipple>
      
      <div class="relative">
        <div class="absolute inset-0 bg-gradient-to-br from-[#124B99] to-[#509EE3] rounded-xl blur opacity-30 group-hover:opacity-50 transition-opacity"></div>
        <div class="relative bg-gradient-to-br from-blue-50 to-indigo-50 hover:from-white hover:to-blue-50 transition-all p-3 rounded-xl shadow-md group-hover:shadow-lg">
          <img class="w-10 drop-shadow-lg transform group-hover:scale-110 transition-transform duration-300" src="assets/images/tsn.png" alt="logo">
        </div>
      </div>

      <div class="flex flex-col">
        <span class="text-2xl font-bold tracking-tight bg-gradient-to-r from-[#124B99] via-[#509EE3] to-[#03406C] bg-clip-text text-transparent drop-shadow-sm">
          ePaper
        </span>
        <span class="text-[10px] text-gray-500 font-medium tracking-wide uppercase">
          Corporate Portal
        </span>
      </div>

      <!-- Status Badge -->
      <div class="ml-auto">
        <div class="w-2 h-2 bg-green-500 rounded-full animate-pulse shadow-lg shadow-green-500/50"></div>
      </div>
    </div>

    <!-- Sidebar (below header) -->
    <aside
      class="relative text-white bg-gradient-to-br from-[#0B285A] via-[#124B99] to-[#1A4A9C]
             w-[280px] flex flex-col shadow-2xl border-r border-white/10 rounded-tr-3xl
             overflow-hidden mt-4 flex-grow backdrop-blur-sm">

      <!-- Decorative Elements -->
      <div class="absolute top-0 right-0 w-40 h-40 bg-blue-400/10 rounded-full blur-3xl"></div>
      <div class="absolute bottom-20 left-0 w-32 h-32 bg-indigo-400/10 rounded-full blur-3xl"></div>

      <!-- Angled top decoration -->
      <div class="absolute -top-10 left-0 w-full h-12 bg-gradient-to-r from-[#124B99] to-[#509EE3] rotate-[-2deg] origin-top-left shadow-xl opacity-80"></div>
      
      <!-- Top accent line -->
      <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent"></div>

      <!-- Welcome Section -->
      <div class="relative z-10 px-6 pt-8 pb-4 border-b border-white/10">
        <div class="flex items-center gap-3 mb-2">
          <div class="w-10 h-10 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center shadow-lg">
            <mat-icon class="text-white text-xl">business</mat-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-white">Welcome back!</p>
            <p class="text-xs text-white/70">
              {{ isCorporateReader ? 'Corporate Reader' : (isPersonalUser ? 'Personal User' : 'Corporate Admin') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Menu -->
      <nav class="flex-1 overflow-y-auto py-4 custom-scroll relative z-10">
        <!-- Menu Section Title -->
        <div class="flex items-center gap-2 uppercase text-[10px] text-blue-200 font-bold px-6 mb-3 tracking-widest">
          <div class="w-1 h-4 bg-yellow-400 rounded-full"></div>
          <span>Corporate Menu</span>
        </div>

        <!-- Today Trends - Always Visible -->
        <div
          routerLink="/corporate/today-trends"
          routerLinkActive="!bg-gradient-to-r from-yellow-400/20 to-orange-400/20 !text-yellow-300 shadow-lg border-l-4 border-yellow-400"
          [routerLinkActiveOptions]="{ exact: true }"
          class="relative flex items-center gap-3 py-3.5 px-5 mx-3 my-1.5 rounded-xl cursor-pointer 
                 transition-all duration-300 hover:bg-white/10 hover:shadow-md hover:pl-6 group
                 backdrop-blur-sm border border-transparent hover:border-white/20">
          
          <!-- Hover glow effect -->
          <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-yellow-400/0 to-orange-400/0 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

          <!-- Icon Container -->
          <div class="relative flex items-center justify-center w-9 h-9 rounded-lg 
                      bg-white/10 group-hover:bg-yellow-400/20 transition-all duration-300 
                      group-hover:scale-110 group-hover:rotate-3 shadow-sm">
            <mat-icon class="text-white/90 group-hover:text-yellow-300 transition-all duration-300 !text-xl">
              trending_up
            </mat-icon>
          </div>

          <!-- Menu Text -->
          <span class="relative z-10 grow text-[14px] font-semibold tracking-wide 
                       text-white/90 group-hover:text-yellow-300 transition-all duration-300">
            Today Trends
          </span>
        </div>

        <!-- Conditional Menu Items -->
        <ng-container *ngIf="!isCorporateReader">
          
          <!-- Billing -->
          <div
            routerLink="/corporate/billing"
            routerLinkActive="!bg-gradient-to-r from-yellow-400/20 to-orange-400/20 !text-yellow-300 shadow-lg border-l-4 border-yellow-400"
            [routerLinkActiveOptions]="{ exact: true }"
            class="relative flex items-center gap-3 py-3.5 px-5 mx-3 my-1.5 rounded-xl cursor-pointer 
                   transition-all duration-300 hover:bg-white/10 hover:shadow-md hover:pl-6 group
                   backdrop-blur-sm border border-transparent hover:border-white/20">
            
            <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-yellow-400/0 to-orange-400/0 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

            <div class="relative flex items-center justify-center w-9 h-9 rounded-lg 
                        bg-white/10 group-hover:bg-yellow-400/20 transition-all duration-300 
                        group-hover:scale-110 group-hover:rotate-3 shadow-sm">
              <mat-icon class="text-white/90 group-hover:text-yellow-300 transition-all duration-300 !text-xl">
                receipt_long
              </mat-icon>
            </div>

            <span class="relative z-10 grow text-[14px] font-semibold tracking-wide 
                         text-white/90 group-hover:text-yellow-300 transition-all duration-300">
              Billing
            </span>
          </div>

          <!-- Readers (not for personal users) -->
          <ng-container *ngIf="!isPersonalUser">
            <div
              routerLink="/corporate/readers"
              routerLinkActive="!bg-gradient-to-r from-yellow-400/20 to-orange-400/20 !text-yellow-300 shadow-lg border-l-4 border-yellow-400"
              [routerLinkActiveOptions]="{ exact: true }"
              class="relative flex items-center gap-3 py-3.5 px-5 mx-3 my-1.5 rounded-xl cursor-pointer 
                     transition-all duration-300 hover:bg-white/10 hover:shadow-md hover:pl-6 group
                     backdrop-blur-sm border border-transparent hover:border-white/20">
              
              <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-yellow-400/0 to-orange-400/0 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

              <div class="relative flex items-center justify-center w-9 h-9 rounded-lg 
                          bg-white/10 group-hover:bg-yellow-400/20 transition-all duration-300 
                          group-hover:scale-110 group-hover:rotate-3 shadow-sm">
                <mat-icon class="text-white/90 group-hover:text-yellow-300 transition-all duration-300 !text-xl">
                  groups
                </mat-icon>
              </div>

              <span class="relative z-10 grow text-[14px] font-semibold tracking-wide 
                           text-white/90 group-hover:text-yellow-300 transition-all duration-300">
                Readers
              </span>
            </div>
          </ng-container>

          <!-- Subscription -->
          <div
            routerLink="/corporate/subscription"
            routerLinkActive="!bg-gradient-to-r from-yellow-400/20 to-orange-400/20 !text-yellow-300 shadow-lg border-l-4 border-yellow-400"
            [routerLinkActiveOptions]="{ exact: true }"
            class="relative flex items-center gap-3 py-3.5 px-5 mx-3 my-1.5 rounded-xl cursor-pointer 
                   transition-all duration-300 hover:bg-white/10 hover:shadow-md hover:pl-6 group
                   backdrop-blur-sm border border-transparent hover:border-white/20">
            
            <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-yellow-400/0 to-orange-400/0 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

            <div class="relative flex items-center justify-center w-9 h-9 rounded-lg 
                        bg-white/10 group-hover:bg-yellow-400/20 transition-all duration-300 
                        group-hover:scale-110 group-hover:rotate-3 shadow-sm">
              <mat-icon class="text-white/90 group-hover:text-yellow-300 transition-all duration-300 !text-xl">
                workspace_premium
              </mat-icon>
            </div>

            <span class="relative z-10 grow text-[14px] font-semibold tracking-wide 
                         text-white/90 group-hover:text-yellow-300 transition-all duration-300">
              Subscription
            </span>
          </div>

          <!-- Payment -->
          <div
            routerLink="/corporate/payment"
            routerLinkActive="!bg-gradient-to-r from-yellow-400/20 to-orange-400/20 !text-yellow-300 shadow-lg border-l-4 border-yellow-400"
            [routerLinkActiveOptions]="{ exact: true }"
            class="relative flex items-center gap-3 py-3.5 px-5 mx-3 my-1.5 rounded-xl cursor-pointer 
                   transition-all duration-300 hover:bg-white/10 hover:shadow-md hover:pl-6 group
                   backdrop-blur-sm border border-transparent hover:border-white/20">
            
            <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-yellow-400/0 to-orange-400/0 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

            <div class="relative flex items-center justify-center w-9 h-9 rounded-lg 
                        bg-white/10 group-hover:bg-yellow-400/20 transition-all duration-300 
                        group-hover:scale-110 group-hover:rotate-3 shadow-sm">
              <mat-icon class="text-white/90 group-hover:text-yellow-300 transition-all duration-300 !text-xl">
                payments
              </mat-icon>
            </div>

            <span class="relative z-10 grow text-[14px] font-semibold tracking-wide 
                         text-white/90 group-hover:text-yellow-300 transition-all duration-300">
              Payment
            </span>
          </div>

        </ng-container>
      </nav>

      <!-- Quick Actions Section -->
      <div class="relative z-10 px-4 py-3 border-t border-white/10 bg-white/5">
        <div class="flex items-center justify-around">
          <button class="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-white/10 transition-all group">
            <mat-icon class="text-white/70 group-hover:text-yellow-300 !text-xl transition-colors">help_outline</mat-icon>
            <span class="text-[9px] text-white/70 group-hover:text-yellow-300 transition-colors">Help</span>
          </button>
          <button class="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-white/10 transition-all group">
            <mat-icon class="text-white/70 group-hover:text-yellow-300 !text-xl transition-colors">settings</mat-icon>
            <span class="text-[9px] text-white/70 group-hover:text-yellow-300 transition-colors">Settings</span>
          </button>
          <button class="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-white/10 transition-all group">
            <mat-icon class="text-white/70 group-hover:text-yellow-300 !text-xl transition-colors">notifications</mat-icon>
            <span class="text-[9px] text-white/70 group-hover:text-yellow-300 transition-colors">Alerts</span>
          </button>
        </div>
      </div>

      <!-- Logout Section -->
      <div class="relative z-10 p-4 border-t border-white/10 bg-gradient-to-r from-white/5 to-white/10 backdrop-blur-sm">
        <button
          class="w-full flex items-center gap-3 bg-gradient-to-r from-red-500/20 to-orange-500/20 
                 hover:from-red-500/30 hover:to-orange-500/30 text-white py-3 px-4 rounded-xl 
                 transition-all duration-300 group shadow-lg hover:shadow-xl border border-red-400/30
                 hover:border-red-400/50">
          <div class="bg-gradient-to-br from-red-500 to-orange-500 text-white rounded-full p-2 
                      flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
            <mat-icon class="!text-lg">power_settings_new</mat-icon>
          </div>
          <div class="flex flex-col items-start">
            <span class="text-sm font-bold tracking-wide">Logout</span>
            <span class="text-[10px] text-white/70">End your session</span>
          </div>
          <mat-icon class="ml-auto text-white/50 group-hover:text-white transition-colors">exit_to_app</mat-icon>
        </button>
      </div>

      <!-- Bottom accent line -->
      <div class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent"></div>
    </aside>
  </div>

  <style>
    /* Custom Scrollbar */
    .custom-scroll::-webkit-scrollbar {
      width: 6px;
    }

    .custom-scroll::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 10px;
    }

    .custom-scroll::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px;
      transition: background 0.3s;
    }

    .custom-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    /* Smooth scrollbar for Firefox */
    .custom-scroll {
      scrollbar-width: thin;
      scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
    }

    /* Pulse animation for notification badge */
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.7;
        transform: scale(1.1);
      }
    }

    .animate-pulse {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    /* Rotate animation for expand icon */
    .rotate-180 {
      transform: rotate(180deg);
    }
  </style>

  <!-- Main Content -->
  <main class="flex-1 flex flex-col">
    <!-- Top Navigation Bar -->
    <div class="relative z-50">
      <app-top-nav-bar></app-top-nav-bar>
    </div>

    <!-- Content Area -->
    <section class="flex-1 overflow-y-auto p-6 bg-gray-50">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>